import {
  LoaderArgs,
  RouteObjectWithPlugins,
  useRenderedRouteLoaderData,
} from '@/reactRouterPlugins';
import { datasetTaxonLoader } from '@/routes/taxon/key/taxonKey';
import { DatasetKeyAbout } from './about';
import { DatasetKeyDashboard } from './dashboard';
import {
  DatasetKeyLoaderResult,
  datasetLoader,
  DatasetPage,
  DatasetPageSkeleton,
} from './datasetKey';
import { DatasetKeyDownload } from './download';
import DatasetEvents from './event/datasetEvents';
import { DatasetEventID, eventLoader } from './event/eventID';
import { DatasetKeyPhylo } from './phylogenies';
import { DatasetKeyProject } from './project';
import { DatasetKeyTaxonSearch } from './taxonSearch';
import { redirectDocument } from 'react-router-dom';
import { DatasetTaxonKey } from './taxonKey';
const id = 'datasetKey';

export const datasetKeyRoute: RouteObjectWithPlugins = {
  id,
  gbifRedirect: ({ key } = {}, { gbifOrgLocalePrefix = '' }) => {
    if (typeof key !== 'string' && typeof key !== 'number')
      throw new Error(`'Invalid key (key is of type ${typeof key})`);
    if (key === 'search') return null;
    return `${import.meta.env.PUBLIC_GBIF_ORG}${gbifOrgLocalePrefix}/dataset/${key}`;
  },
  path: 'dataset/:key',
  loader: datasetLoader,
  loadingElement: <DatasetPageSkeleton />,
  element: <DatasetPage />,
  children: [
    {
      index: true,
      element: <DatasetKeyAbout />,
    },
    {
      path: 'activity',
      loader: () => redirectDocument('../metrics'),
    },
    {
      path: 'metrics',
      element: <DatasetKeyDashboard />,
    },
    {
      path: 'project',
      element: <DatasetKeyProject />,
    },
    {
      path: 'phylogenies',
      element: <DatasetKeyPhylo />,
    },
    {
      path: 'taxon',
      element: <DatasetKeyTaxonSearch />,
    },
    {
      path: 'taxon/:taxonKey',
      element: <DatasetTaxonKey />,
      loader: datasetTaxonLoader,
    },
    {
      path: 'event',
      element: <DatasetEvents />,
      loader: datasetLoader,
    },
    {
      path: 'event/:eventID',
      element: <DatasetEventID />,
      loader: eventLoader,
    },
    {
      path: 'parentevent/:parentEventID',
      element: <DatasetEventID />,
      loader: ({ params }: LoaderArgs) => redirectDocument(`../event/${params.parentEventID}`),
    },
    {
      path: 'download',
      element: <DatasetKeyDownload />,
    },
  ],
};

export function useDatasetKeyLoaderData() {
  return useRenderedRouteLoaderData(id) as DatasetKeyLoaderResult;
}
